import { toast, ToastContainer } from 'react-toastify'
import classes from './informMe.module.scss'
import { useState } from 'react';
import { count } from 'console';

interface props {
  planName: string,
  monthlyOrYearly: string
}

export default function InformMe({ planName, monthlyOrYearly }: props) {
  const apiUrl = `${process.env.REACT_APP_BASE_URL}/ContactSales`; // Replace with your API endpoint

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [country, setCountry] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // Prevent default form submission

    const requestBody = {
      firstName,
      lastName,
      email,
      phone,
      country,
      planName,
      monthlyOrYearly
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      const responseData = await response.json();

      if (!responseData.failed) {
        toast.success("Thanks for the interest you shown in next generation Smile Design, someone from our Sales Team will contact you soon. An invitation mail to sign up to the platform will be sent to your shortly.");
        setFirstName('');
        setLastName('');
        setEmail('');
        setPhone('');
        setCountry('');
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    } catch (error) {
      toast.error("Failed to submit your request. Please check your network connection.");
    }
  };

  return (
    <div className={classes.inform}>
      <ToastContainer style={{ zIndex: 99999 }} position="top-center" autoClose={8000} hideProgressBar={true} closeOnClick pauseOnHover />

      <span className={classes.title}>Stay Updated on Our Plans!</span>
      <p className={classes.subtitle}>To be the first to know about the launch of our plans, please provide your details below.</p>
      <form onSubmit={handleSubmit}>
        <div className={classes.formGroup}>
          <input type="text" name="firstName" placeholder="First Name" value={firstName}
            onChange={(e) => setFirstName(e.target.value)} required />
        </div>
        <div className={classes.formGroup}>
          <input type="text" name="lastName" placeholder="Last Name" value={lastName}
            onChange={(e) => setLastName(e.target.value)} required />
        </div>
        <div className={classes.formGroup}>
          <input name="email" type="email" placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className={classes.formGroup}>
          <input name="phone" type="tel" placeholder="Phone" value={phone}
            onChange={(e) => setPhone(e.target.value)} required />
        </div>
        <div className={classes.formGroup}>
          <input name="country" type="text" placeholder="Country" value={country}
            onChange={(e) => setCountry(e.target.value)} required />
        </div>
        <p>
          By submitting this form, you consent to Implant Genius Enterprises Inc's Terms of Service and <a href='/privacy-policy' target='_blank'>Privacy Policy</a>.
        </p>
        <button type="submit" className={classes.submitButton}>Submit</button>
      </form>
    </div>
  )
}
